import { BackendACCRole } from "../backend/BackendACCRole";
import { ACCProjectProduct } from "../ACCProjectProduct";
import { FrontendACCProjectProducts } from "./FrontendACCProjectProducts";
import { BIM360ProjectService } from "../BIM360ProjectService";
import { ERegion } from "../ERegion";
import { FrontendBIM360ProjectServices } from "./FrontendBIM360ProjectServices";
import { DataConnectorCompany } from "../DataConnectorCompany";
import { SettingsV2 } from "../SettingsV2";

export class SettingsHubProjectRole {
  public memberGroupId: string | null = null;
  public name: string | null = null;
  public projectId: string | null = null;
  public roleId: string | null = null;
  public static fromJSON(json: any) {
    const hubProjectRole = new SettingsHubProjectRole();
    hubProjectRole.memberGroupId = json?.memberGroupId;
    hubProjectRole.name = json?.name;
    hubProjectRole.projectId = json?.projectId;
    hubProjectRole.roleId = json?.roleId;
    return hubProjectRole;
  }
}

export class SettingsHubProject {
  public coordinateModuleEnabled: boolean = false;
  public hubId: string | null = null;
  public id: string | null = null;
  public issueContainerId: string | null = null;
  public issueModuleEnabled: boolean = false;
  public docSyncModuleEnabled: boolean = false;
  public locationContainerId: boolean = false;
  public name: string | null = null;
  public url: string | null = null;
  public projectListModuleEnabled: boolean = false;
  public static fromJSON(json: any) {
    const hubProject = new SettingsHubProject();
    hubProject.coordinateModuleEnabled = json?.coordinateModuleEnabled;
    hubProject.hubId = json?.hubId;
    hubProject.id = json?.id;
    hubProject.issueContainerId = json?.issueContainerId;
    hubProject.issueModuleEnabled = json?.issueModuleEnabled;
    hubProject.docSyncModuleEnabled = json?.docSyncModuleEnabled;
    hubProject.locationContainerId = json?.locationContainerId;
    hubProject.name = json?.name;
    hubProject.url = json?.url;
    hubProject.projectListModuleEnabled = json?.projectListModuleEnabled;
    return hubProject;
  }
}

export class SettingsHub {
  public coordinateModuleRole: SettingsHubProjectRole | null = null;
  public id: string | null = null;
  public issueModuleRole: SettingsHubProjectRole | null = null;
  public docSyncModuleRole: SettingsHubProjectRole | null = null;
  public projectListModuleRole: SettingsHubProjectRole | null = null;
  public projectListModuleRoles: BackendACCRole[]= [];
  public memberGroupId: string | null = null;
  public name: string | null = null;
  public projectId: string | null = null;
  public projects: SettingsHubProject[] = [];
  public roleId: string | null = null;
  public roles: SettingsHubProjectRole[] = [];
  public type: string | null = null;
  public url: string | null = null;
  public accProjectRolesList: BackendACCRole[] = [];
  public usersWithRoles: UserWithRole[] = [];
  public companies: DataConnectorCompany[] = [];
  public region: ERegion = ERegion.US;
  public ccEmails: string[] = [];
  public allowedDomains: string[] = [];
  public skipApprovalPage: boolean = false;
  public defaultACCProjectRoles: BackendACCRole[] = [];
  public defaultACCProjectProducts: FrontendACCProjectProducts = new FrontendACCProjectProducts();
  public defaultBIM360ProjectServices: FrontendBIM360ProjectServices = new FrontendBIM360ProjectServices();//BIM360ProjectService[] =[];
  public defaultCompany: DataConnectorCompany | null = null;
  public static fromJSON(json: any) {
    const hub = new SettingsHub();
    hub.coordinateModuleRole = json?.coordinateModuleRole;
    hub.docSyncModuleRole = json?.docSyncModuleRole;
    hub.id = json?.id;
    hub.issueModuleRole = json?.issueModuleRole;
    hub.memberGroupId = json?.memberGroupId;
    hub.name = json?.name;
    hub.projectId = json?.projectId;
    hub.projects = json?.projects.map((p: any) =>
      SettingsHubProject.fromJSON(p)
    );
    hub.id = json?.id;
    hub.roleId = json?.roleId;
    hub.roles = json?.roles.map((r: any) => SettingsHubProjectRole.fromJSON(r));
    hub.type = json?.type;
    hub.url = json?.url;
    hub.projectListModuleRole = json?.projectListModuleRole;
    hub.region = json?.region;
    return hub;
  }

  public readSettingsFromLicenses(allLicenses: License[]) {
    // let metadataForHub:MetaDataHub[] = [];
    for (const l of allLicenses) {
      if (l.product_code == process.env.VUE_APP_ISSUE_PRODUCT_CODE) {
        const theHubMetadata = l.metadata?.hubs.find((h) => h.hubId == this.id);
        if (theHubMetadata) {
          const foundRole = this.roles.find(
            (r) => r.roleId == theHubMetadata.roleId
          );
          if (foundRole) this.issueModuleRole = foundRole; //set role selector

          //set project ModuleEnabled
          for (const project of theHubMetadata.projects) {
            const hubProject = this.projects.find((p) => p.id == project.id);
            if (hubProject) hubProject.issueModuleEnabled = true;
          }
        }
      } else if (
        l.product_code == process.env.VUE_APP_COORDINATE_PRODUCT_CODE
      ) {
        const theHubMetadata = l.metadata?.hubs.find((h) => h.hubId == this.id);
        if (theHubMetadata) {
          const foundRole = this.roles.find(
            (r) => r.roleId == theHubMetadata.roleId
          );
          if (foundRole) this.coordinateModuleRole = foundRole; //set role selector
          for (const project of theHubMetadata.projects) {
            const hubProject = this.projects.find((p) => p.id == project.id);
            if (hubProject) hubProject.coordinateModuleEnabled = true;
          }
        }
      } else if (l.product_code == process.env.VUE_APP_SP_DOC_SYNC_PRODUCT_CODE) {
        const theHubMetadata = l.metadata?.hubs.find((h) => h.hubId == this.id);
        if (theHubMetadata) {
          const foundRole = this.roles.find(
            (r) => r.roleId == theHubMetadata.roleId
          );
          if (foundRole) this.docSyncModuleRole = foundRole; //set role selector
          for (const project of theHubMetadata.projects) {
            const hubProject = this.projects.find((p) => p.id == project.id);
            if (hubProject) hubProject.docSyncModuleEnabled = true;
          }
        }
      }
      else if (l.product_code == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE) {
        const theHubMetadata = l.metadata?.hubs.find(h => h.hubId == this.id);
        if (theHubMetadata) {
          const foundRole = this.roles.find(r => r.roleId == theHubMetadata.roleId);
          if (foundRole) this.projectListModuleRole = foundRole;//set role selector
          for (const project of theHubMetadata.projects) {
            const hubProject = this.projects.find(p => p.id == project.id);
            if (hubProject) hubProject.projectListModuleEnabled = true;
          }
          //Load accProjectRolesList
          this.projectListModuleRoles = theHubMetadata?.allowedRoles || [];
          this.accProjectRolesList = theHubMetadata?.accProjectRolesList || [];
          this.usersWithRoles = theHubMetadata?.usersWithRoles || [];
          this.companies = theHubMetadata?.companies || [];
          this.skipApprovalPage = theHubMetadata?.skipApprovalPage;
          this.ccEmails = theHubMetadata?.ccEmails ?? [];
          this.allowedDomains = theHubMetadata?.allowedDomains ?? [];
          this.defaultACCProjectRoles = theHubMetadata?.defaultACCProjectRoles;
          this.defaultACCProjectProducts = theHubMetadata?.defaultACCProjectProducts;
          this.defaultBIM360ProjectServices = theHubMetadata?.defaultBIM360ProjectServices;
          this.defaultCompany = theHubMetadata?.defaultCompany;
        }
      }
    }
  }
}

// export class MetadataHub {
//   public hubId: string | null = null;
//   public projects: { id: string }[] = [];
//   public roleId: string | null = null;
//   public static fromJSON(json: any) {
//     const metadataHub = new MetadataHub();
//     metadataHub.hubId = json?.hubId;
//     metadataHub.projects = json?.projects;
//     metadataHub.roleId = json?.roleId;
//     return metadataHub;
//   }
// }

class MetaDataHubProject {
  id: string = "";
  public static fromJSON(json: any) {
    const p = new MetaDataHubProject();
    p.id = json?.id;
    return p;
  }
}

export class UserWithRole {
  id: string = ""; 
  autodesk_id: string = "";
  name: string= ""; 
  email: string= "";
  roles: {
      role_id: string;
      role_name: string;
  }[] = [];

  public static fromJSON(json: any) {
    const u = new UserWithRole();
    u.id = json?.id;
    u.autodesk_id = json?.autodesk_id;
    u.name = json?.name;
    u.email = json?.email;
    u.roles = json?.roles.length ? json.roles : [];
    return u;
  }
}

export class MetaDataHub {
  public hubId: string = "";
  public projects: MetaDataHubProject[] = [];
  public roleId: string = "";
  public allowedRoles: BackendACCRole[] = [];
  public accProjectRolesList: BackendACCRole[] = [];
  public usersWithRoles: UserWithRole[] = [];
  public companies: DataConnectorCompany[] = [];
  public region: ERegion = ERegion.US;
  public ccEmails: string[] = [];
  public allowedDomains: string[] = [];
  public skipApprovalPage: boolean = false;
  public defaultACCProjectRoles: BackendACCRole[] = [];
  public defaultACCProjectProducts = new FrontendACCProjectProducts();
  public defaultBIM360ProjectServices = new FrontendBIM360ProjectServices();
  public defaultCompany: DataConnectorCompany | null = null;
  public static fromJSON(json: any) {
    const h = new MetaDataHub();
    h.hubId = json?.hubId;
    h.projects = json?.projects.map((p: any) => MetaDataHubProject.fromJSON(p));
    h.roleId = json?.roleId;
    h.allowedRoles = json?.allowedRoles;
    h.accProjectRolesList = json?.accProjectRolesList;
    h.usersWithRoles = json?.usersWithRoles;
    h.companies = json?.companies;
    h.region = json?.region;
    h.ccEmails = json?.ccEmails;
    h.allowedDomains = json?.allowedDomains;
    h.skipApprovalPage = json?.skipApprovalPage;
    h.defaultACCProjectRoles = json?.defaultACCProjectRoles;
    h.defaultACCProjectProducts = FrontendACCProjectProducts.fromJSON(json?.defaultACCProjectProducts);
    h.defaultBIM360ProjectServices = FrontendBIM360ProjectServices.fromJSON(json?.defaultBIM360ProjectServices);
    h.defaultCompany = json?.defaultCompany;
    return h;
  }
}

export class Metadata {
  public hubs: MetaDataHub[] = [];
  public hubsV2?: SettingsV2[] = [];
  public static fromJSON(json: any) {
    const metadata = new Metadata();
    if (json && json.hubs)
      metadata.hubs = json.hubs.map((h: any) => MetaDataHub.fromJSON(h));
    if (json && json.hubsV2)
      metadata.hubsV2 = json.hubsV2;
    return metadata;
  }
}

export class License {
  public client_id: string | null = null;
  public contacts: { email: string; forge_id: string; _id: string }[] = [];
  public contract_manager: string | null = null;
  public metadata: Metadata | null = null;
  public name: Metadata | null = null;
  public product_code: string | null = null;
  public product_ref: string | null = null;
  public seats: number | null = null;
  public type: string | null = null;
  public _id: string | null = null;
  public static fromJSON(json: any) {
    const l = new License();
    l.client_id = json?.client_id;
    l.contacts = json?.contacts;
    l.contract_manager = json?.contract_manager;
    l.metadata = Metadata.fromJSON(json?.metadata);
    l.name = json?.name;
    l.product_code = json?.product_code;
    l.product_ref = json?.product_ref;
    l.seats = json?.seats;
    l.type = json?.type;
    l._id = json?._id;
    return l;
  }
}

export class Settings {
  public is_allowed = false;
  public action_required = false;
  public hubs: SettingsHub[] = [];
  public uploadingSettings = false;

  public licenses: License[] = [];

  public constructor() {}
}